var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer" },
    [
      _c("popup", {
        staticClass: "popup",
        attrs: { opened: _vm.openData, "use-header": true, "use-footer": true },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function() {
              return [
                _c("h2", [
                  _vm._v(_vm._s(/*신청 상세 내용*/ _vm.$t("MPAY-04-01-10-22")))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "divider" }, [
                  _c("span", { staticClass: "divider-date" }, [
                    _vm._v(
                      _vm._s(/*신청 일시*/ _vm.$t("MPAY-04-01-11-02")) +
                        " : " +
                        _vm._s(_vm.$getGlobalDateFmt(_vm.detailInfo.drblYms))
                    )
                  ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*이체 결과*/ _vm.$t("MPAY-04-01-13-03")))
                  ])
                ]),
                _c("dl", { staticClass: "dlist dlist-item--type6" }, [
                  _c("dt", [
                    _vm._v(_vm._s(/* 이체 구분 */ _vm.$t("MPAY-04-01-12-04")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(/* 타행 이체 */ _vm.$t("MINQ-01-01-06-18")))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*신청 일시*/ _vm.$t("MPAY-04-01-07-02")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(
                      _vm._s(_vm.$getGlobalDateFmt(_vm.detailInfo.drblYmd))
                    )
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*처리상태*/ _vm.$t("MPAY-04-01-11-17")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          _vm.detailInfo.ovsesRmtancPrcssDstcd +
                            "_해외송금처리구분코드"
                        )
                      )
                    )
                  ])
                ]),
                _vm.siteCode == _vm.$config.SITECODE_OGHCM &&
                _vm.detailInfo.rmtancPtrnDstcd != "03"
                  ? [
                      _c("div", { staticClass: "info info-etc-col" }, [
                        _vm._v(
                          _vm._s(
                            /*실제 거래 결과는 거래내역조회에서 하실 수 있습니다.*/ "※ " +
                              _vm.$t("MFXD-01-02-02-08")
                          )
                        )
                      ])
                    ]
                  : _vm._e(),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*출금 정보*/ _vm.$t("MPAY-04-01-12-09")))
                  ])
                ]),
                _c("dl", { staticClass: "dlist dlist-item--type6" }, [
                  _c("dt", [
                    _vm._v(
                      _vm._s(/*출금 계좌 번호*/ _vm.$t("MPAY-04-01-12-10"))
                    )
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.drwotAcno))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*예금주명*/ _vm.$t("MLON-01-01-11-05")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.drwotDpstrName))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*출금 금액*/ _vm.$t("MPAY-04-01-12-12")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(_vm.detailInfo.drwotCncycd))
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.anticiDrwotAmt)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*수수료*/ _vm.$t("MPAY-04-01-10-06")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(_vm.detailInfo.drwotCncycd))
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.anticiFee)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*송금메모*/ _vm.$t("MPAY-04-01-10-07")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.drwotTrsaccMemo))
                  ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*입금 정보*/ _vm.$t("MPAY-04-01-10-08")))
                  ])
                ]),
                _c(
                  "dl",
                  { staticClass: "dlist dlist-item--type6" },
                  [
                    _vm.siteCode != _vm.$config.SITECODE_OGAUC
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 은행명 */ _vm.$t("MPAY-04-01-10-09"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.mnrcvOthrBnkName))
                          ])
                        ]
                      : _vm._e(),
                    _vm.siteCode == _vm.$config.SITECODE_OGMMR ||
                    _vm.siteCode == _vm.$config.SITECODE_OGIND
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 입금 지점 */ _vm.$t("MPAY-02-01-26-17"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.mnrcvBrnName))
                          ])
                        ]
                      : _vm._e(),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*입금 계좌번호*/ _vm.$t("MPAY-04-01-10-10"))
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.mnrcvAcno))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*입금 금액*/ _vm.$t("MPAY-04-01-10-11")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _c("span", { staticClass: "exchange-unit" }, [
                        _vm._v(_vm._s(_vm.detailInfo.mnrcvCncycd))
                      ]),
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(_vm._s(_vm.$num(_vm.detailInfo.mnrcvTrsaccAmt)))
                      ])
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("MPAY-04-01-12-17")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.mnrcvDpstrName))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*Particulars*/ /*수취인 참조내용*/ _vm.siteCode ==
                            _vm.$config.SITECODE_OGAUC
                            ? _vm.$t("MPAY-02-01-12-22")
                            : _vm.$t("MPAY-04-01-06-A14")
                        )
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.mnrcvDraweRefCtnt))
                    ]),
                    _vm.siteCode == _vm.$config.SITECODE_OGAUC
                      ? [
                          _c("dt", [
                            _vm._v(_vm._s(/*Code*/ _vm.$t("MPAY-04-01-10-13")))
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.draweCd))
                          ]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*Reference*/ _vm.$t("MPAY-02-01-12-21"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.remark))
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPAY-04-01-12-19")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }